"use client";

import { lightTheme } from "@rainbow-me/rainbowkit";
import { mainnet } from "viem/chains";

export const rainbowKitInitialProps = {
  initialChain: mainnet,
  theme: lightTheme({
    borderRadius: "small",
    fontStack: "system",
    overlayBlur: "none",

    ...lightTheme.accentColors.purple,
  }),
};
